import dayjs from 'dayjs';

export const QUESTION_TYPE_LABELS = {
  text: 'Text',
  date: 'Date',
  single_choice: 'Single choice',
  multi_choice: 'Multiple choice',
};

export function normalizeQuestionnaireResponse(value) {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return value;
      }
    }

    if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return value;
      }
    }

    return value;
  }

  return value;
}

export function hasQuestionnaireAnswer(value) {
  const normalized = normalizeQuestionnaireResponse(value);
  if (normalized === null) return false;
  if (Array.isArray(normalized)) return normalized.length > 0;
  if (typeof normalized === 'string') return normalized.trim().length > 0;
  return true;
}

export function formatQuestionnaireAnswer(value, questionType) {
  const normalized = normalizeQuestionnaireResponse(value);
  if (normalized === null) return null;

  const type = String(questionType || '').toLowerCase();

  if (type === 'multi_choice' && Array.isArray(normalized)) {
    return normalized.join(', ');
  }

  if (type === 'date') {
    const parsed = dayjs(normalized);
    return parsed.isValid() ? parsed.format('DD MMM YYYY') : String(normalized);
  }

  if (Array.isArray(normalized)) {
    return normalized.join(', ');
  }

  if (typeof normalized === 'object') {
    return JSON.stringify(normalized);
  }

  return String(normalized);
}

export function getQuestionnaireSummary(items = []) {
  const questions = Array.isArray(items) ? items : [];
  const answered = questions.filter((item) => hasQuestionnaireAnswer(item?.response_value));
  const mandatoryUnanswered = questions.filter(
    (item) => item?.is_mandatory && !hasQuestionnaireAnswer(item?.response_value)
  );

  return {
    total: questions.length,
    answered: answered.length,
    unanswered: questions.length - answered.length,
    mandatoryUnanswered: mandatoryUnanswered.length,
  };
}
